export function referralAgreementCP826() {
return [   // Release 2026-09-02 13:04:07
 
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.055,
   left: 161.88,
   width: 373.80,
   height: 11.160
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 130.76,
   left: 252.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Clients", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 152.72,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Referring Broker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 174.8,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Referring Broker State and License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 196.76,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Referring Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 218.6,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Referring Brokerage Firm EIN", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 240.56,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Receiving Licensee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 262.52,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Receiving Broker State and License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 284.6,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Receiving Brokerage Firm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 306.56,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Referral Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 328.52,
   left: 253.12,
   width: 285.12,
   height: 13.385
}
,
{
   page: 0,
   name: "Brokerage Firm agree that in the event the Receiving Licensee receives credit for any gross", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 394.56,
   left: 390.6,
   width: 143.4,
   height: 13.08
}
,
{
   page: 0,
   name: "Signature Agent Referring", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 570.44,
   left: 72.0,
   width: 216.24,
   height: 13.385
}
,
{
   page: 0,
   name: "Signature Agent Receiving Referral", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 570.439,
   left: 324.12,
   width: 216.24,
   height: 13.386
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.48,
   left: 161.88,
   width: 373.80,
   height: 10.08
}
,
{
   page: 1,
   name: "Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 165.665,
   left: 119.76,
   width: 206.76,
   height: 37.800
}
,
{
   page: 1,
   name: "When to make initial contact", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 176.793,
   left: 329.04,
   width: 252.84,
   height: 27.327
}
,
{
   page: 1,
   name: "Address", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 205.145,
   left: 106.44,
   width: 220.44,
   height: 26.040
}
,
{
   page: 1,
   name: "CityStateZip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 233.16,
   left: 125.04,
   width: 202.20,
   height: 14.16
}
,
{
   page: 1,
   name: "Property address to be listed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 215.978,
   left: 332.072,
   width: 249.808,
   height: 31.342
}
,
{
   page: 1,
   name: "Business Phone", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 249,
   left: 130.8,
   width: 196.08,
   height: 26.04
}
,
{
   page: 1,
   name: "Cell Phone", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 276.84,
   left: 114.6,
   width: 212.28,
   height: 26.04
}
,
{
   page: 1,
   name: "Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 304.2,
   left: 90.84,
   width: 236.40,
   height: 14.16
}
,
{
   page: 1,
   name: "Additional Helpful Information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 260.487,
   left: 330.512,
   width: 252.023,
   height: 57.873
}
,
{
   page: 1,
   name: "Buyers Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 356.28,
   left: 125.4,
   width: 201.48,
   height: 26.04
}
,
{
   page: 1,
   name: "New Employer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 356.28,
   left: 383.28,
   width: 198.96,
   height: 26.04
}
,
{
   page: 1,
   name: "Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 383.76,
   left: 106.08,
   width: 221.16,
   height: 14.88
}
,
{
   page: 1,
   name: "Address_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 383.76,
   left: 361.44,
   width: 221.16,
   height: 14.88
}
,
{
   page: 1,
   name: "CityStateZip_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 399.96,
   left: 125.04,
   width: 202.20,
   height: 14.16
}
,
{
   page: 1,
   name: "CityStateZip_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 399.96,
   left: 380.4,
   width: 202.2,
   height: 14.16
}
,
{
   page: 1,
   name: "Business Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 415.44,
   left: 130.44,
   width: 196.80,
   height: 14.88
}
,
{
   page: 1,
   name: "Position and Approximate Salary", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 415.44,
   left: 440.88,
   width: 141.72,
   height: 14.88
}
,
{
   page: 1,
   name: "Cell Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 431.76,
   left: 114.24,
   width: 213.00,
   height: 14.88
}
,
{
   page: 1,
   name: "Must home be sold first", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 431.76,
   left: 414.12,
   width: 168.48,
   height: 14.88
}
,
{
   page: 1,
   name: "Fax_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 447.96,
   left: 90.84,
   width: 236.40,
   height: 13.92
}
,
{
   page: 1,
   name: "Company buyout", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 447.96,
   left: 392.64,
   width: 189.96,
   height: 13.92
}
,
{
   page: 1,
   name: "Preferred Location", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 463.56,
   left: 140.88,
   width: 186.00,
   height: 26.04
}
,
{
   page: 1,
   name: "Cash Available for Purchase and Closing Costs", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 463.56,
   left: 483.36,
   width: 98.88,
   height: 26.04
}
,
{
   page: 1,
   name: "Size and Type of Home Desired", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 491.16,
   left: 180.96,
   width: 145.80,
   height: 28.80
}
,
{
   page: 1,
   name: "Contact Buyer at this no first By this date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 491.16,
   left: 430.56,
   width: 151.56,
   height: 28.80
}
,
{
   page: 1,
   name: "Price Range", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 521.64,
   left: 125.76,
   width: 201.12,
   height: 26.04
}
,
{
   page: 1,
   name: "Expected Arrival Date Moving Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 521.64,
   left: 405.48,
   width: 176.76,
   height: 26.04
}
,
{
   page: 1,
   name: "Number in Family", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 549.72,
   left: 138.895,
   width: 188.280,
   height: 38.64
}
,
{
   page: 1,
   name: "Adults", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 589.8,
   left: 118.56,
   width: 208.68,
   height: 14.88
}
,
{
   page: 1,
   name: "Children Age", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 606,
   left: 198.36,
   width: 128.88,
   height: 13.92
}
,
{
   page: 1,
   name: "Age", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 638.236,
   left: 202.451,
   width: 122.705,
   height: 24.415
}
,
{
   page: 1,
   name: "Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558.884,
   left: 331.473,
   width: 250.407,
   height: 105.731
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 1,
   name: "Text11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 621.203,
   left: 202.91,
   width: 123.164,
   height: 14.800
}
,
{
   page: 1,
   name: "Text12", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 622.475,
   left: 76.5821,
   width: 109.4179,
   height: 39.673
}
] }
